import React, { useState, useEffect } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Row, Col, Select, Form, message, DatePicker, Input, Spin, Skeleton, Button } from 'antd';
import FreeText from '../MassupdateJson/newFreeText.json';
import ListOfValues from '../MassupdateJson/newListOfValues.json';
import Dates from '../MassupdateJson/newDate.json';
import Date1 from '../MassupdateJson/newDate1.json';
import Boolean from '../MassupdateJson/newBoolean.json';
import Numbers from '../MassupdateJson/newNumber.json';
import { FetchAllGroup } from '../../../Api/Services/UserGroupApiService';
import { FetchAllServiceLines } from '../../../Api/Services/ServiceLineApiService';
import { tasktypeApi, taskstatusApi, } from '../../../Api/Services/TaskapiService';
import { FetchAllLead, } from '../../../Api/Services/LeadApiServices'; // FetchAllLeadBycompany
import { FetchAllContact } from '../../../Api/Services/ContactApiService'; // FetchAllContactByCompany
import { getCasebuReportingUser, getFollowingCasebyUser, getCompanyCase } from '../../../Api/Services/CaseApiServices';
import { DealTypeAPi, PriorityDealApi, HoldReasonapi, wonReasonApi, LostReasonApi, FetchAllDeal, FetchAllPipeline } from '../../../Api/Services/DealApiService';
import { FetchAllAccount, FetchAllAccountType, FetchAllOwnership, FetchAllCustomerstatus, AccountsByAccountType } from '../../../Api/Services/AccountApiService';
import {
    getTimeZoneData, getUserDepartment, getDateFormate, getTimeFormate, getSystemRole, getCompanyRole, getAllUsersByAdmin, getProdCategory,
    getAllUsersData, IndustryData, getLeadsourceData, getTitle, getLeadStatusData, getRating, getSeniorityLevelData, getCountryData, getNoofEmployee, getAnnualRevenue
} from '../../../Api/Services/CommonApiService';

const getSessionStamp = () => {
    const now = new Date();
    const pad = (n, width = 2) => String(n).padStart(width, "0");

    return (
        now.getFullYear().toString() +
        pad(now.getMonth() + 1) +
        pad(now.getDate()) +
        pad(now.getHours()) +
        pad(now.getMinutes()) +
        pad(now.getSeconds()) +
        pad(now.getMilliseconds(), 3)
    );
};
let groupIdCounter = 0;
let conditionIdCounter = 0;
const sessionStamp = getSessionStamp();
const createUniqueId = (prefix, counter) => `${prefix}${counter}-${sessionStamp}`;
const createEmptyCondition = (relation = "and") => {
    conditionIdCounter += 1;
    return {
        type: 'condition',
        id: createUniqueId("condition", conditionIdCounter),
        field: null,
        operator: null,
        value: null,
        relationWithPrevious: relation,
    };
};
const createEmptyGroup = () => {
    groupIdCounter += 1;
    return {
        type: 'group',
        id: createUniqueId("group", groupIdCounter),
        relationWithPrevious: 'and',
        items: [createEmptyCondition()],
    };
};
const QueryBuilderFunction = ({ currencySettings, isEditable, viewType, queryField, group, setGroup, pageFor, setUiLoad, uiLoad, frontendGroup, setFrontendGroup, pageFrom }) => {
    const { Option } = Select;
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
    const [dropdownLoaded, setDropdownLoaded] = useState(false);
    const [users, setUsers] = useState()
    const [leadsource, setLeadSource] = useState()
    const [leadStatus, setLeadStatus] = useState()
    const [revenue, setRevenue] = useState()
    const [account, setAccount] = useState()
    const [account2, setAccount2] = useState()
    const [seniority, setSeniority] = useState()
    const [seniority1, setSeniority1] = useState()
    const [taskType, setTaskType] = useState()
    const [accountbyType, setAccountbyType] = useState()
    const [taskStatus, setTaskStatus] = useState()
    const [noofemployee, setNoofemployee] = useState()
    const [contact, setContact] = useState()
    const [rating, SetRating] = useState()
    const [typeData, setTypeData] = useState()
    const [titles, setTitles] = useState()
    const [leadCity, setLeadCity] = useState()
    const [leadState, setLeadState] = useState()
    const [contactCity, setContactCity] = useState()
    const [contactState, setContactState] = useState()
    const [accountCity, setAccountCity] = useState()
    const [accountState, setAccountState] = useState()
    const [dealListData, setDealListData] = useState()
    const [ownerShipData, setOwnershipData] = useState()
    const [customerStatus, setCustomerStatus] = useState()
    const [industryData, setIndustryData] = useState()
    const [dealPriority, setDealPriority] = useState()
    const [pipeLineStage, setPipelineStage] = useState()
    const [dealType, setDealType] = useState()
    const [dealOnHold, setDealOnHold] = useState()
    const [userCity, setUserCity] = useState()
    const [userState, setUserState] = useState()
    const [dealWon, setDealWon] = useState()
    const [dealLost, setDealLost] = useState()
    const [department, setDepartment] = useState()
    const [allTimeZone, setAllTimeZone] = useState()
    // const [allLanguage, setAllLanguage] = useState()
    const [dateFormateList, setDateFormateList] = useState()
    const [timeFormateList, setTimeFormateList] = useState()
    const [allCountry, setAllCountry] = useState()
    const [allRole, setAllRole] = useState()
    // const [creatorList, setCreatorList] = useState()
    const [allCaseList, setAllCaseList] = useState()
    const [caseAccounts, setCaseAccounts] = useState()
    const [productCat, setProductCat] = useState()
    const [allCompanyRole, setAllCompanyRole] = useState()
    const [allusergroupList, setAllusergroupList] = useState()
    const [serviceData, setServiceData] = useState()
    // const [highlightIds, setHighlightIds] = useState([]);
    const [leadCountry, setLeadCountry] = useState()
    const [userCountry, setUserCountry] = useState()
    const [contactCountry, setContactCountry] = useState()
    const [accountCountry, setAccountCountry] = useState()
    const GetProductCategory = async () => {
        try {
            const data = await getProdCategory()
            const options = data?.map((option, i) => (
                <Option value={option.productCategory} key={i} data={option.productCategory}>
                    {option.productCategory}
                </Option>))
            setProductCat(options)
        }
        catch (error) {
            setProductCat([])
            message.error(error)
        }
    }
    async function CaseApi() {
        try {
            const data = await getCasebuReportingUser()
            const response = await getFollowingCasebyUser()
            const mergedCases = [
                ...data,
                ...response.filter(fc => !data.some(rc => rc.caseId === fc.caseId))
            ];
            const uniqueAccounts = Array.from(
                new Map(mergedCases?.map(item => [item.accountName, item])).values()
            );
            const optionss = uniqueAccounts?.map((option, i) => (
                <Option key={i} value={option.accountName} data={option.accountName}>
                    {option.accountName}
                </Option>
            ))
            setCaseAccounts(optionss)
        } catch (error) {
            setCaseAccounts([])
            message.error(error)
        }
    }
    async function GetAllServiceLine() {
        try {
            const data = await FetchAllServiceLines();
            setServiceData(data);
        } catch (error) {
            setServiceData([]);
            message.error(error);
        }
    }
    const getList = async () => {
        try {
            const data = await getCompanyCase()
            setAllCaseList(data)
        }
        catch (error) {
            setAllCaseList([])
            message.error(error)
        }
    }
    // async function CreatorListApi() {
    //     try {
    //         const Lead = await FetchAllLeadBycompany()
    //         const contact = await FetchAllContactByCompany()
    //         const formattedLeads = Lead?.map(item => ({
    //             id: item.leadsId,
    //             name: `${item.firstName} ${item.lastName}`,
    //             email: item.primaryEmail,
    //             type: "Leads",
    //         }));
    //         const formattedContacts = contact?.map(item => ({
    //             id: item.contactsId,
    //             name: `${item.firstName} ${item.lastName}`,
    //             email: item.email,
    //             type: "Contacts",
    //         }));
    //         const data = await getCasebuReportingUser()
    //         const response = await getFollowingCasebyUser()
    //         const mergedCases = [
    //             ...data,
    //             ...response.filter(fc => !data.some(rc => rc.caseId === fc.caseId))
    //         ];
    //         const uniqueAccounts = Array.from(
    //             new Map(mergedCases?.map(item => [item.caseCreater, item])).values()
    //         );
    //         const formattedrequestor = uniqueAccounts?.map(item => ({
    //             id: null,
    //             name: item.caseCreater,
    //             email: null,
    //             type: null,
    //         }));
    //         // const options = [...formattedLeads, ...formattedContacts, ...formattedrequestor];
    //         // const uniqueOptions = Array.from(
    //         //     new Map(options?.map(item => [item.name?.trim().toLowerCase(), item])).values()
    //         // );
    //         // const optionss = uniqueOptions?.map(option => ({
    //         //     label: (<div className='UserList-dropdown'>
    //         //         <div>
    //         //             <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
    //         //                 {option.name.slice(0, 1).toUpperCase()}
    //         //             </span>
    //         //         </div>
    //         //         <div>
    //         //             <p style={{ fontWeight: 'bold', margin: 0 }}>{option.name}</p>
    //         //             <p style={{ margin: 0 }}>{option.type ? `(${option.type})` : ""}</p>
    //         //         </div>
    //         //     </div>),
    //         //     value: option.name,
    //         //     key: option.name
    //         // }));
    //         // setCreatorList(optionss)
    //     }
    //     catch (error) {
    //         message.error(error)
    //     }
    // }
    async function getTimeFormateList() {
        try {
            const response = await getTimeFormate()
            const option = response?.map((option, i) => (
                <Option key={i} value={option.timeFormat} data={option.timeFormat}>
                    {option.timeFormat}
                </Option>
            ))
            setTimeFormateList(option)
        } catch (error) {
            setTimeFormateList([])
            message.error(error)
        }
    }
    async function getDateFormateList() {
        try {
            const response = await getDateFormate()
            const option = response?.map((option, i) => (
                <Option key={i} value={option.dateFormat} data={option.dateFormat}>
                    {option.dateFormat}
                </Option>
            ))
            setDateFormateList(option)
        } catch (error) {
            setDateFormateList([])
            message.error(error)
        }
    }
    async function GetAllUsersList() {
        try {
            const data = await getAllUsersByAdmin()
            const uniqueCountry = Array.from(new Set(data?.map(option => option.country).filter(country => country !== null && country !== undefined && country !== '')));
            const country = uniqueCountry?.map((country, i) => (
                <Option key={i} value={country} data={country}>
                    {country}
                </Option>
            ))
            setUserCountry(country)
            const uniqueState = Array.from(new Set(data?.map(option => option.state).filter(state => state !== null && state !== undefined && state !== '')));
            const state = uniqueState?.map((state, i) => (
                <Option key={i} value={state} data={state}>
                    {state}
                </Option>
            ))
            setUserState(state)
            const uniqueCity = Array.from(new Set(data?.map(option => option.city).filter(city => city !== null && city !== undefined && city !== '')));
            const city = uniqueCity?.map((city, i) => (
                <Option key={i} value={city} data={city}>
                    {city}
                </Option>
            ))
            setUserCity(city)
        } catch (error) {
            setUserCountry([])
            setUserState([])
            setUserState([])
            message.error(error)
        }
    }
    // async function getAllLanguage() {
    //     try {
    //         const response = await getLanguage()
    //         setAllLanguage(response)
    //     } catch (error) {
    //         setAllLanguage([])
    //         message.error(error)
    //     }
    // }
    async function getAlltimeZone() {
        try {
            const response = await getTimeZoneData()
            setAllTimeZone(response)
        } catch (error) {
            setAllTimeZone([])
            message.error(error)
        }
    }
    async function AllCompanyRole() {
        try {
            const response = await getCompanyRole()
            setAllCompanyRole(response);
        } catch (error) {
            setAllCompanyRole([]);
            message.error(error)
        }
    }
    async function AllRole() {
        try {
            const response = await getSystemRole()
            const filteredResponse = response.filter(item => item.roleName !== "Super Admin");
            setAllRole(filteredResponse);
        } catch (error) {
            setAllRole([]);
            message.error(error);
        }
    }
    async function getdepartemtnUser() {
        try {
            const response = await getUserDepartment()
            const option = response?.map((option, i) => (
                <Option key={i} value={option.department} data={option.department}>
                    {option.department}
                </Option>
            ))
            setDepartment(option)
        } catch (error) {
            setDepartment([])
            message.error(error)
        }
    }
    async function GetUsergroupList() {
        try {
            const response = await FetchAllGroup()
            const withUserCounts = response.data?.map(group => ({
                ...group,
                groupUserCount: group.userId
                    ? group.userId.split(",").filter(id => id.trim() !== "").length
                    : 0
            }));
            setAllusergroupList(withUserCounts)
        } catch (error) {
            setAllusergroupList([])
            message.error(error)
        }
    }
    const getTitleData = async () => {
        try {
            const data = await getTitle()
            const options = data?.map((option, i) => (
                <Option value={option.title} key={i} data={option.title}>
                    {option.title}
                </Option>));
            setTitles(options)
        }
        catch (error) {
            setTitles([])
            message.error(error)
        }
    }
    const DealsApi = async () => {
        try {
            const data = await FetchAllDeal()
            setDealListData(data)
        }
        catch (error) {
            setDealListData([])
            message.error(error)
        }
    }
    async function getAllAccoutbyType() {
        try {
            const data = await AccountsByAccountType()
            setAccountbyType(data)
        }
        catch (error) {
            setAccountbyType([])
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            setUsers(data)
        }
        catch (error) {
            setUsers([])
            message.error(error)
        }
    }
    const getSeniorityLevel = async () => {
        try {
            const data = await getSeniorityLevelData()
            const options = data?.map((option, i) => (
                <Option value={option.seniorityLevelId} key={i} data={option.seniorityLevel}>
                    {option.seniorityLevel}
                </Option>));
            setSeniority(options)
            const options1 = data?.map((option, i) => (
                <Option value={option.seniorityLevel} key={i} data={option.seniorityLevel}>
                    {option.seniorityLevel}
                </Option>));
            setSeniority1(options1)
        }
        catch (error) {
            setSeniority([])
            setSeniority1([])
            message.error(error)
        }
    }
    const getAllCustomerstatus = async () => {
        try {
            const data = await FetchAllCustomerstatus()
            const options = data?.map((option, i) => (
                <Option value={option.customerStatus} key={i} data={option.customerStatus}>
                    {option.customerStatus}
                </Option>))
            setCustomerStatus(options)
        }
        catch (error) {
            setCustomerStatus([])
            message.error(error)
        }
    }
    const getRatingData = async () => {
        try {
            const data = await getRating()
            const options = data?.map((option, i) => (
                <Option value={option.rating} key={i} data={option.rating}>
                    {option.rating}
                </Option>));
            SetRating(options)
        }
        catch (error) {
            SetRating([])
            message.error(error)
        }
    }
    const getAnnualRevenueData = async () => {
        try {
            const data = await getAnnualRevenue()
            const options = data?.map((option, i) => (
                <Option value={option.annualRevenue} key={i} data={option.annualRevenue}>
                    {option.annualRevenue}
                </Option>));
            setRevenue(options)
        }
        catch (error) {
            setRevenue([])
            message.error(error)
        }
    }
    async function ContactApi() {
        try {
            const data = await FetchAllContact()
            setContact(data)
            const uniqueCountry = Array.from(new Set(data?.map(option => option.country).filter(country => country !== null && country !== undefined && country !== '')));
            const country = uniqueCountry?.map((country, i) => (
                <Option key={i} value={country} data={country}>
                    {country}
                </Option>
            ))
            setContactCountry(country)
            const uniqueState = Array.from(new Set(data?.map(option => option.state).filter(state => state !== null && state !== undefined && state !== '')));
            const state = uniqueState?.map((state, i) => (
                <Option key={i} value={state} data={state}>
                    {state}
                </Option>
            ))
            setContactState(state)
            const uniqueCity = Array.from(new Set(data?.map(option => option.city).filter(city => city !== null && city !== undefined && city !== '')));
            const city = uniqueCity?.map((city, i) => (
                <Option key={i} value={city} data={city}>
                    {city}
                </Option>
            ))
            setContactCity(city)
        }
        catch (error) {
            setContact([])
            setContactCity([])
            setContactState([])
            setContactCountry([])
            message.error(error)
        }
    }
    const getLeadsource = async () => {
        try {
            const data = await getLeadsourceData()
            setLeadSource(data)
        }
        catch (error) {
            setLeadSource([])
            message.error(error)
        }
    }
    const getLeadStatus = async () => {
        try {
            const data = await getLeadStatusData()
            setLeadStatus(data)
        }
        catch (error) {
            setLeadStatus([])
            message.error(error)
        }
    }
    const TaskTypeApi = async () => {
        try {
            const data = await tasktypeApi()
            setTaskType(data)
        }
        catch (error) {
            setTaskType([])
            message.error(error)
        }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
        }
        catch (error) {
            setAllCountry([])
            message.error(error)
        }
    }
    async function TypeDataApi() {
        try {
            const data = await FetchAllAccountType()
            let typeData;
            if (profile.roleName !== "Administrator") {
                typeData = data.filter((item) => item.accountTypeName === "Customer")
            } else {
                typeData = data
            }
            setTypeData(typeData)
        }
        catch (error) {
            setTypeData([])
            message.error(error)
        }
    }
    async function OwnerShipDataApi() {
        try {
            const data = await FetchAllOwnership()
            setOwnershipData(data)
        }
        catch (error) {
            setOwnershipData([])
            message.error(error)
        }
    }
    async function IndustryDataApi() {
        try {
            const data = await IndustryData()
            setIndustryData(data)
        }
        catch (error) {
            setIndustryData([])
            message.error(error)
        }
    }
    async function dealWonReason() {
        try {
            const data = await wonReasonApi()
            setDealWon(data)
        }
        catch (error) {
            setDealWon([])
            message.error(error)
        }
    }
    async function dealLostReason() {
        try {
            const data = await LostReasonApi()
            setDealLost(data)
        }
        catch (error) {
            setDealLost([])
            message.error(error)
        }
    }
    async function DealOnHoldApi() {
        try {
            const data = await HoldReasonapi()
            setDealOnHold(data)
        }
        catch (error) {
            setDealOnHold([])
            message.error(error)
        }
    }
    async function PriorityApi() {
        try {
            const data = await PriorityDealApi()
            setDealPriority(data)
        }
        catch (error) {
            setDealPriority([])
            message.error(error)
        }
    }
    async function DealTypeApi() {
        try {
            const data = await DealTypeAPi()
            setDealType(data)
        }
        catch (error) {
            setDealType([])
            message.error(error)
        }
    }
    const getPipelineStage = async () => {
        try {
            const data = await FetchAllPipeline()
            setPipelineStage(data)
        }
        catch (error) {
            setPipelineStage([])
            message.error(error)
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            setAccount(data)
            const uniqueCountry = Array.from(new Set(data?.map(option => option.country).filter(country => country !== null && country !== undefined && country !== '')));
            const country = uniqueCountry?.map((country, i) => (
                <Option key={i} value={country} data={country}>
                    {country}
                </Option>
            ))
            setAccountCountry(country)
            const uniqueState = Array.from(new Set(data?.map(option => option.state).filter(state => state !== null && state !== undefined && state !== '')));
            const state = uniqueState?.map((state, i) => (
                <Option key={i} value={state} data={state}>
                    {state}
                </Option>
            ))
            setAccountState(state)
            const uniqueCity = Array.from(new Set(data?.map(option => option.city).filter(city => city !== null && city !== undefined && city !== '')));
            const city = uniqueCity?.map((city, i) => (
                <Option key={i} value={city} data={city}>
                    {city}
                </Option>
            ))
            setAccountCity(city)
        }
        catch (error) {
            setAccount([])
            setAccountCountry([])
            setAccountState([])
            setAccountCity([])
            message.error(error)
        }
    }
    async function LeadApi() {
        try {
            const data = await FetchAllLead()
            const uniqueAccounts = Array.from(
                new Map(data?.map(item => [item.account_name, item])).values()
            );
            const options = uniqueAccounts?.map((option, i) => (
                <Option key={i} value={option.account_name} data={option.account_name}>
                    {option.account_name}
                </Option>
            ))
            setAccount2(options)
            const uniqueCountry = Array.from(new Set(data?.map(option => option.country).filter(country => country !== null && country !== undefined && country !== '')));
            const country = uniqueCountry?.map((country, i) => (
                <Option key={i} value={country} data={country}>
                    {country}
                </Option>
            ))
            setLeadCountry(country)
            const uniqueState = Array.from(new Set(data?.map(option => option.state).filter(state => state !== null && state !== undefined && state !== '')));
            const state = uniqueState?.map((state, i) => (
                <Option key={i} value={state} data={state}>
                    {state}
                </Option>
            ))
            setLeadState(state)
            const uniqueCity = Array.from(new Set(data?.map(option => option.city).filter(city => city !== null && city !== undefined && city !== '')));
            const city = uniqueCity?.map((city, i) => (
                <Option key={i} value={city} data={city}>
                    {city}
                </Option>
            ))
            setLeadCity(city)
        }
        catch (error) {
            setAccount2([])
            setLeadCountry([])
            setLeadState([])
            setLeadCity([])
            message.error(error)
        }
    }
    const TaskStatusApi = async () => {
        try {
            const data = await taskstatusApi()
            setTaskStatus(data)
        }
        catch (error) {
            setTaskStatus([])
            message.error(error)
        }
    }
    const getNomEmployeeData = async () => {
        try {
            const data = await getNoofEmployee()
            const options = data?.map((option, i) => (
                <Option value={option.nomOfEmployee} key={i} data={option.nomOfEmployee}>
                    {option.nomOfEmployee}
                </Option>));
            setNoofemployee(options)
        }
        catch (error) {
            setNoofemployee([])
            message.error(error)
        }
    }
    const noValueConditions = new Set([
        "IS NOT NULL", "IS NULL",
        "today", "tomorrow", "yesterday",
        "this_week", "next_week", "last_week",
        "this_month", "next_month", "last_month",
        "this_financial_year", "next_financial_year", "last_financial_year",
        "this_quarter", "next_quarter", "last_quarter"
    ]);
    const singleValueMapping = {
        Lead: { account_name: account2, state: leadState, city: leadCity, country: leadCountry },
        Contact: { state: contactState, city: contactCity, country: contactCountry },
        Account: { state: accountState, city: accountCity, country: accountCountry },
        User: { state: userState, city: userCity, country: userCountry },
        Case: { account_name: caseAccounts },
    };
    const arrayOptionsMapping = {
        country: allCountry,
        case_owner: users,
        parent_case: allCaseList,
        child_case: allCaseList,
        followers: users,
        service_line_owner: users,
        task_owner: users,
        email: users,
        reporting_manager_id: users,
        assign_to: users,
        parent_service_line: serviceData,
        manufacturer_name: accountbyType,
        lead_owner: users,
        account_owner: users,
        deal_owner: users,
        date_format: dateFormateList,
        Time_format: timeFormateList,
        company_role_id: allCompanyRole,
        time_zone: allTimeZone,
        // language: allLanguage,
        role_id: allRole,
        department,
        seniority_level_id: seniority,
        organization_level: seniority1,
        user_group_ids: allusergroupList,
        account_id: account,
        account_name: account,
        contact_person: contact,
        parent_organization: account,
        task_type_id: taskType,
        lead_source_id: leadsource,
        contact_source_id: leadsource,
        lead_status_id: leadStatus,
        task_status_id: taskStatus,
        reporting_to: contact,
        competition: accountbyType,
        parent_deal_id: dealListData,
        account_type: typeData,
        industry: industryData,
        ownership: ownerShipData,
        deal_type: dealType,
        pipeline_stage: pipeLineStage,
        priority: dealPriority,
        annual_revenue: revenue,
        nom_of_employees: noofemployee,
        customer_status: customerStatus,
        product_category: productCat,
        rating,
        title: titles,
        deal_hold_reason: dealOnHold,
        deal_lost_reason: dealLost,
        deal_won_reason: dealWon,
        language: [{}],
        resell: [{}],
        case_type: [{}],
        case_status: [{}],
        case_origin: [{}],
        case_priority: [{}],
        subtype: [{}],
        commit_status: [{}],
        qualified: [{}],
        margin_calculation_method: [{}],
        product_active: [{}],
        email_opt_out: [{}],
        email_otp_out: [{}],
        is_converted: [{}],
    };
    const singleValueApiMapping = {
        Lead: { account_name: LeadApi, state: LeadApi, city: LeadApi, country: LeadApi },
        Contact: { state: ContactApi, city: ContactApi, country: ContactApi },
        Account: { state: AccountApi, city: AccountApi, country: AccountApi },
        User: { state: GetAllUsersList, city: GetAllUsersList, country: GetAllUsersList },
        Case: { account_name: CaseApi },
    };
    const arrayOptionsApiMapping = {
        country: getCountry,
        case_owner: UserDetailsApi,
        parent_case: getList,
        child_case: getList,
        followers: UserDetailsApi,
        service_line_owner: UserDetailsApi,
        task_owner: UserDetailsApi,
        email: UserDetailsApi,
        reporting_manager_id: UserDetailsApi,
        assign_to: UserDetailsApi,
        parent_service_line: GetAllServiceLine,
        manufacturer_name: getAllAccoutbyType,
        lead_owner: UserDetailsApi,
        account_owner: UserDetailsApi,
        deal_owner: UserDetailsApi,
        date_format: getDateFormateList,
        Time_format: getTimeFormateList,
        company_role_id: AllCompanyRole,
        time_zone: getAlltimeZone,
        // language: getAllLanguage,
        role_id: AllRole,
        department: getdepartemtnUser,
        seniority_level_id: getSeniorityLevel,
        organization_level: getSeniorityLevel,
        user_group_ids: GetUsergroupList,
        account_id: AccountApi,
        account_name: AccountApi,
        contact_person: ContactApi,
        parent_organization: AccountApi,
        task_type_id: TaskTypeApi,
        lead_source_id: getLeadsource,
        contact_source_id: getLeadsource,
        lead_status_id: getLeadStatus,
        task_status_id: TaskStatusApi,
        reporting_to: ContactApi,
        competition: getAllAccoutbyType,
        parent_deal_id: DealsApi,
        account_type: TypeDataApi,
        industry: IndustryDataApi,
        ownership: OwnerShipDataApi,
        deal_type: DealTypeApi,
        pipeline_stage: getPipelineStage,
        priority: PriorityApi,
        annual_revenue: getAnnualRevenueData,
        nom_of_employees: getNomEmployeeData,
        customer_status: getAllCustomerstatus,
        product_category: GetProductCategory,
        rating: getRatingData,
        title: getTitleData,
        deal_hold_reason: DealOnHoldApi,
        deal_lost_reason: dealLostReason,
        deal_won_reason: dealWonReason,
    };
    const collectDropdownFields = (group, viewType) => {
        if (!group) return [];
        let result = [];
        (group.items || []).forEach((item) => {
            if (item.type === "condition" && item.field) {
                result.push({
                    moduleName: viewType || null,
                    field: item.field,
                });
            }
            else if (item.type === "group") {
                result = result.concat(collectDropdownFields(item, viewType));
            }
        });
        (group.groups || []).forEach((subGroup) => {
            result = result.concat(collectDropdownFields(subGroup, viewType));
        });
        return result;
    };
    const isDropdownField = (field) =>
        Object.keys(arrayOptionsApiMapping).includes(field) ||
        Object.values(singleValueApiMapping).some((apis) => apis[field]);
    const triggerDropdownApis = (fields) => {
        const called = new Set();
        fields.forEach(({ moduleName, field }) => {
            if (!isDropdownField(field)) return;
            let apiFn = null;
            if (moduleName && singleValueApiMapping[moduleName]?.[field]) {
                apiFn = singleValueApiMapping[moduleName][field];
            } else if (arrayOptionsApiMapping[field]) {
                apiFn = arrayOptionsApiMapping[field];
            }

            if (apiFn) {
                const key = `${moduleName || "Global"}-${field}`;
                if (!called.has(key)) {
                    setTimeout(() => {
                        apiFn()
                    }, 0);
                    called.add(key);
                }
            }
        });
    };
    useEffect(() => {
        const fetchAll = async () => {
            if (pageFor === "New") {
                const newCondition = createEmptyGroup();
                setGroup(newCondition);
                if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
                    setFrontendGroup(newCondition)
                }
            }
            setUiLoad(true);
        };
        if (pageFor) {
            fetchAll();
        }
    }, [pageFor]);
    useEffect(() => {
        if (
            pageFor === "Edit" &&
            group &&
            group.items?.length > 0 &&
            !dropdownLoaded
        ) {
            const dropdownFields = collectDropdownFields(group, viewType);
            triggerDropdownApis(dropdownFields);
            setDropdownLoaded(true);
        }
    }, [group, pageFor]);
    const updateGroupTree = (current, updater) => {
        if (current.type === 'group') {
            const updated = updater(current);
            return {
                ...updated,
                items: updated.items?.map((item) =>
                    item.type === 'group' ? updateGroupTree(item, updater) : item
                ),
            };
        }
        return current;
    };
    const updateGroupRelationWithPrevious = (groupId, value) => {
        const updater = (g) => {
            if (!g.items) return g;
            const idx = g.items.findIndex((item) => item.id === groupId);
            if (idx === -1) return g;
            const newItems = [...g.items];
            if (newItems[idx].type === "group") {
                newItems[idx] = { ...newItems[idx], relationWithPrevious: value };
                let forward = idx + 1;
                while (forward < newItems.length && newItems[forward].type === "group") {
                    newItems[forward] = { ...newItems[forward], relationWithPrevious: value };
                    forward += 1;
                }
                let backward = idx - 1;
                while (backward >= 0 && newItems[backward].type === "group") {
                    newItems[backward] = { ...newItems[backward], relationWithPrevious: value };
                    backward -= 1;
                }
            }
            return { ...g, items: newItems };
        };
        setGroup(updateGroupTree(group, updater));
        if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
            setFrontendGroup(updateGroupTree(frontendGroup, updater));
        }
    };
    const addConditionToGroup = (groupId) => {
        let newCondition = null;
        const updatedGroup = updateGroupTree(group, (g) => {
            if (g.id === groupId) {
                const isRoot = g.depth === 0;
                if (isRoot) {
                    newCondition = createEmptyCondition("and");
                } else {
                    const existingRelation =
                        g.items.find(i => i.type === "condition")?.relationWithPrevious || "and";
                    newCondition = createEmptyCondition(existingRelation);
                }
                return {
                    ...g,
                    items: [...g.items, newCondition],
                };
            }
            return g;
        });
        if (!newCondition) return;
        setGroup(updatedGroup);
        if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
            setFrontendGroup(
                updateGroupTree(frontendGroup, (g) => {
                    if (g.id === groupId) {
                        return {
                            ...g,
                            items: [...g.items, newCondition],
                        };
                    }
                    return g;
                })
            );
        }
    };
    const addSubGroup = (groupId) => {
        let newGroup = null;
        const updatedGroup = updateGroupTree(group, (g) => {
            if (g.id === groupId) {
                const items = g.items || [];
                const prev = items[items.length - 1];
                const inheritRelation =
                    prev && prev.type === 'group'
                        ? (prev.relationWithPrevious || 'and')
                        : 'and';
                newGroup = {
                    ...createEmptyGroup(),
                    relationWithPrevious: inheritRelation,
                };
                return {
                    ...g,
                    items: [...items, newGroup],
                };
            }
            return g;
        });
        if (!newGroup) return;
        setGroup(updatedGroup);
        if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
            setFrontendGroup(
                updateGroupTree(frontendGroup, (g) => {
                    if (g.id === groupId) {
                        return {
                            ...g,
                            items: [...(g.items || []), newGroup],
                        };
                    }
                    return g;
                })
            );
        }
    };
    const deleteCondition = (groupId, conditionId) => {
        const updater = (tree) => {
            if (tree.id !== groupId) return tree;
            const index = tree.items.findIndex(
                (i) => i.type === 'condition' && i.id === conditionId
            );
            if (index === -1) return tree;
            const newItems = [...tree.items];

            const prevGroup = newItems
                .slice(0, index)
                .reverse()
                .find((i) => i.type === "group");
            let nextIndex = index + 1;
            while (newItems[nextIndex] && newItems[nextIndex].type === "group") {
                newItems[nextIndex] = {
                    ...newItems[nextIndex],
                    relationWithPrevious: prevGroup
                        ? prevGroup.relationWithPrevious
                        : "and",
                };
                nextIndex += 1;
            }
            newItems.splice(index, 1);
            const hasPreviousCondition = newItems
                .slice(0, index)
                .some((i) => i.type === "condition");
            if (!hasPreviousCondition) {
                while (newItems[index] && newItems[index].type === "group") {
                    newItems.splice(index, 1);
                }
            }
            if (!newItems.some((i) => i.type === "condition")) {
                newItems.push(createEmptyCondition());
            }
            return { ...tree, items: newItems };
        };
        setGroup(updateGroupTree(group, updater));
        if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
            setFrontendGroup(updateGroupTree(frontendGroup, updater));
        }
    };
    const deleteGroup = (groupId) => {
        const deleteRecursive = (current) => {
            if (!current.items || !Array.isArray(current.items)) return current;
            return {
                ...current,
                items: current.items
                    ?.map((item) => {
                        if (item.type === 'group') {
                            return item.id === groupId
                                ? null
                                : deleteRecursive(item);
                        }
                        return item;
                    })
                    .filter((item) => item !== null),
            };
        };
        setGroup(deleteRecursive(group));
        if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
            setFrontendGroup(deleteRecursive(frontendGroup));
        }
    };
    const updateCondition = (groupId, conditionId, field, value, key, currecy) => {
        setGroup(
            updateGroupTree(group, (g) => {
                if (g.id === groupId) {
                    if (field === 'relationWithPrevious') {
                        return {
                            ...g,
                            items: g.items?.map((item) => {
                                if (item.type === 'condition') {
                                    return { ...item, relationWithPrevious: value };
                                }
                                return item;
                            }),
                        };
                    }
                    return {
                        ...g,
                        items: g.items?.map((item) => {
                            if (item.type === 'condition' && item.id === conditionId) {
                                const updatedItem = {
                                    ...item,
                                    [field]: value,
                                    Key: key,
                                    Currency: currecy,
                                };
                                if (field === 'field') {
                                    updatedItem.operator = null;
                                    updatedItem.value = (value === 'competition' || value === 'contact_person' || value === "followers" || value === "child_case") ? [] : null;
                                    const singleApi = singleValueApiMapping[viewType]?.[value];
                                    if (singleApi) {
                                        singleApi(); // fire & forget
                                    } else {
                                        // 2️⃣ Check array-options mapping (field only)
                                        const arrayApi = arrayOptionsApiMapping[value];
                                        if (arrayApi) arrayApi(); // fire & forget
                                    }
                                } else if (field === 'operator' && noValueConditions.has(value)) {
                                    updatedItem.value = (item.field === 'competition' || item.field === 'contact_person' || item.field === "followers" || item.field === "child_case") ? [] : null;
                                }
                                return updatedItem;
                            }
                            return item;
                        }),
                    }
                }
                return g;
            })
        );
    };
    const updateFrondendCondition = (groupId, conditionId, field, value, key, currecy) => {
        setFrontendGroup(
            updateGroupTree(frontendGroup, (g) => {
                if (g.id === groupId) {
                    if (field === 'relationWithPrevious') {
                        return {
                            ...g,
                            items: g.items?.map((item) => {
                                if (item.type === 'condition') {
                                    return { ...item, relationWithPrevious: value };
                                }
                                return item;
                            }),
                        };
                    }
                    return {
                        ...g,
                        items: g.items?.map((item) => {
                            if (item.type === 'condition' && item.id === conditionId) {
                                const updatedItem = {
                                    ...item,
                                    [field]: value,
                                    Key: key,
                                    Currency: currecy,
                                };
                                if (field === 'field') {
                                    updatedItem.operator = null;
                                    updatedItem.value = (value === 'competition' || value === 'contact_person' || value === "followers" || value === "child_case") ? [] : null;
                                } else if (field === 'operator' && noValueConditions.has(value)) {
                                    updatedItem.value = (item.field === 'competition' || item.field === 'contact_person' || item.field === "followers" || item.field === "child_case") ? [] : null;
                                }
                                return updatedItem;
                            }
                            return item;
                        }),
                    }
                }
                return g;
            })
        );
    };
    // const collectGroupAndDescendantIds = (g) => {
    //     const ids = [g.id];
    //     (g.items || []).forEach((i) => {
    //         if (i.type === 'condition') ids.push(i.id);
    //         if (i.type === 'group') ids.push(...collectGroupAndDescendantIds(i));
    //     });
    //     return ids;
    // };
    // const collectContiguousGroupsAfter = (items, fromIndex) => {
    //     const ids = [];
    //     for (let j = fromIndex + 1; j < items.length; j += 1) {
    //         const it = items[j];
    //         if (it.type !== 'group') break;
    //         ids.push(...collectGroupAndDescendantIds(it));
    //     }
    //     return ids;
    // };
    const isFieldDataReady = (viewType, field) => {
        const singleData = singleValueMapping[viewType]?.[field];
        const arrayData = arrayOptionsMapping[field];
        if (singleData !== undefined) return singleData !== null && singleData !== "";
        if (arrayData !== undefined) return Array.isArray(arrayData) && arrayData.length > 0;
        return false;
    };
    const hasSubgroup = (groupData) => groupData?.items?.some((item) => item.type === 'group');
    const renderGroup = (groupData, indent = 0, depth = 0) => {
        const isRoot = depth === 0;
        const isLevel1 = depth === 1;
        const canAddSubGroup =
            isRoot ||
            (isLevel1 && !hasSubgroup(groupData));
        return (
            <div
                // className='antd-form-item-css'
                key={groupData?.id}
                // style={{
                //     paddingLeft: indent,
                //     margin: "10px 0px",
                //     borderLeft: highlightIds.includes(groupData?.id) ? "2px solid #ff0000" : indent ? '2px solid #ddd' : 'none',
                // }}
                style={{
                    marginLeft: depth * 20,
                    marginBottom: 16,
                    padding: 16,
                    border: '1px solid #e6e9f4',
                    borderRadius: 8,
                    background: depth % 2 === 0 ? '#fff' : '#f8f9fa',
                }}
            >

                {depth > 0 && (<Row gutter={15} style={{ marginBottom: 12 }} >
                    <Col span={3}>
                        <Form.Item>
                            <Select
                                value={groupData?.relationWithPrevious || undefined}
                                placeholder="Relation"
                                onChange={(value) =>
                                    updateGroupRelationWithPrevious(groupData?.id, value)
                                }
                                style={{ width: '100%' }}
                                disabled={
                                    !isEditable || (depth === 1 && (() => {
                                        const parentItems = group?.items || [];
                                        const myIndex = parentItems.findIndex(i => i.id === groupData?.id);
                                        const prevItem = parentItems[myIndex - 1];
                                        return prevItem?.type === "group";
                                    })())
                                }
                            >
                                <Option value="and" data="and">AND</Option>
                                <Option value="or" data="or" >OR</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    {/* <Col span={5}>
                        <Form.Item>
                            <div className={isEditable ? "Hover-Refresh2 back-hover1 able-style" : 'disabled-style'}
                                role="button"
                                tabIndex={0} title='Add Condition'
                                onClick={() => addConditionToGroup(groupData?.id)}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        addConditionToGroup(groupData?.id)
                                    }
                                }}
                                aria-label='Add Condition'
                            > <FeatherIcon icon="plus" size={16} style={{ marginRight: 5 }} /> Condition</div>
                        </Form.Item>
                    </Col>
                    {canAddSubGroup && (
                        <Col span={3}>
                            <Form.Item>
                                <div className={isEditable ? "Hover-Refresh2 back-hover1 able-style" : 'disabled-style'}
                                    role="button"
                                    tabIndex={0} title='Add Group'
                                    onClick={() => addSubGroup(groupData?.id)}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            addSubGroup(groupData?.id)
                                        }
                                    }}
                                    aria-label='Add Group'
                                > <FeatherIcon icon="plus" size={16} style={{ marginRight: 5 }} /> Group</div>
                            </Form.Item>
                        </Col>
                    )}
                    {isEditable && depth > 0 && (
                        <Col span={canAddSubGroup ? 13 : 16}>
                            <Form.Item>
                                <div style={{
                                    textAlign: "end",
                                    marginRight: 20
                                }} title='Delete Group'>
                                    <FeatherIcon icon="trash-2" size={20} className="fetcherDelete-Icon" style={{ marginTop: 13 }} onClick={() => deleteGroup(groupData?.id)}
                                        onMouseEnter={() => setHighlightIds(collectGroupAndDescendantIds(groupData))}
                                        onMouseLeave={() => setHighlightIds([])}
                                    />
                                </div> </Form.Item>
                        </Col>
                    )} */}
                </Row >
                )}
                {groupData?.items?.map((item, index) => {
                    if (item.type === 'condition') {
                        const isOwnerField = [
                            "lead_owner",
                            "account_owner",
                            "deal_owner",
                            "task_owner",
                            "account_id",
                            "account_name",
                            "parent_deal_id",
                            "parent_organization",
                            "assign_to",
                            "reporting_to",
                            "competition",
                            "contact_person",
                            "reporting_manager_id",
                            "manufacturer_name",
                            "service_line_owner",
                            "parent_service_line",
                            "case_owner",
                            "followers",
                            "parent_case",
                            "child_case",
                            "user_group_ids",
                        ].includes(item.field);
                        const shouldValidate = [
                            "win_probability",
                            "actual_deal_margin",
                            "discount_percentage",
                            "expected_deal_length"
                        ].includes(item.field);
                        const isMultiple = [
                            "contact_person",
                            "competition",
                            "followers",
                            "child_case",
                        ].includes(item.field);
                        const ready = isFieldDataReady(viewType, item.field);
                        return (
                            <div key={item.id} style={{ marginBottom: depth % 2 === 0 ? 16 : 0, padding: 12, background: '#f8f9fa', borderRadius: 8 }}>
                                <Row
                                    gutter={15}
                                    align="middle"
                                // style={{ paddingLeft: indent * 1, borderLeft: highlightIds.includes(item.id) ? "2px solid #ff0000" : "none" }}
                                >
                                    {index > 0 && (<Col span={3}>
                                        <Form.Item>
                                            <Select
                                                placeholder="Relation"
                                                value={item.relationWithPrevious}
                                                onChange={(value, option) => {
                                                    updateCondition(groupData?.id, item.id, 'relationWithPrevious', value, item.Key, item.Currency)
                                                    if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
                                                        updateFrondendCondition(groupData?.id, item.id, 'relationWithPrevious', option.data, item.Key, item.Currency)
                                                    }
                                                }}
                                                disabled={!isEditable || (isRoot ? false : index !== 1)}
                                                style={{ width: '100%' }}
                                            >
                                                <Option value="and" data="and">AND</Option>
                                                <Option value="or" data="or" >OR</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    )}
                                    <Col span={index > 0 ? 6 : 9}>
                                        <Form.Item>
                                            <Select placeholder="Select Property"
                                                style={{ width: "100%" }}
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                disabled={!isEditable}
                                                value={item.field}
                                                onChange={(record, option) => {
                                                    const Key = option.FieldType
                                                    const currecnyData = option.FieldData
                                                    updateCondition(groupData?.id, item.id, 'field', record, Key, currecnyData)
                                                    if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
                                                        updateFrondendCondition(groupData?.id, item.id, 'field', option.data, Key, currecnyData)
                                                    }
                                                }}
                                            >
                                                {queryField?.filter((item) => item.filedValue !== "comment" && item.filedValue !== "related_to_id")
                                                    ?.map((option, index) => (
                                                        <Option value={option.filedValue} key={index} FieldType={option.FieldType} FieldData={option.currencyType} data={option.fieldLable}>
                                                            {option.fieldLable}
                                                        </Option>))}
                                            </Select>
                                        </ Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item>
                                            <Select placeholder="Select Condition"
                                                showSearch style={{ width: "100%" }}
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                disabled={!isEditable}
                                                name="operator"
                                                value={item.operator}
                                                onChange={(value, option) => {
                                                    updateCondition(groupData?.id, item.id, 'operator', value, item.Key, item.Currency)
                                                    if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
                                                        updateFrondendCondition(groupData?.id, item.id, 'operator', option.data, item.Key, item.Currency);
                                                    }
                                                }}
                                            >
                                                {item.Key === "Numbers" && Numbers
                                                    ?.map((option) => (
                                                        <Option value={option.condition} key={option.id} data={option.lable}>
                                                            {option.lable}
                                                        </Option>))};
                                                {item.Key === "Free Text" && FreeText
                                                    ?.map((option) => (
                                                        <Option value={option.condition} key={option.id} data={option.lable} >
                                                            {option.lable}
                                                        </Option>))};
                                                {item.Key === "Drop Down" && ListOfValues
                                                    ?.map((option) => (
                                                        <Option value={option.condition} key={option.id} data={option.lable} >
                                                            {option.lable}
                                                        </Option>))};
                                                {item.Key === "Date" && (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === "modified_at" || item.field === "actual_closer_date" || item.field === "deal_hold_date" || item.field === "deal_lost_date") ?
                                                    Date1?.map((option) => (
                                                        <Option value={option.condition} key={option.id} data={option.lable} >
                                                            {option.lable}
                                                        </Option>))
                                                    :
                                                    item.Key === "Date" && Dates?.map((option) => (
                                                        <Option value={option.condition} key={option.id} data={option.lable} >
                                                            {option.lable}
                                                        </Option>))};
                                                {item.Key === "Boolean" && Boolean
                                                    ?.map((option) => (
                                                        <Option value={option.condition} key={option.id} data={option.lable}>
                                                            {option.lable}
                                                        </Option>))};
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={7}>
                                        <Form.Item>
                                            {(item.operator !== 'IS NULL' && item.operator !== 'IS NOT NULL') && (
                                                item.Key === 'Drop Down' ? (<>
                                                    {
                                                        // (viewType === "Lead" || viewType === "Contact" || viewType === "Account" || viewType === "User") && (item.field === "account_name" || item.field === "state" || item.field === "city") ?
                                                        //     <AutoComplete
                                                        //         options={(viewType === "Lead" && item.field === "account_name") ? account2 :
                                                        //             (viewType === "Lead" && item.field === "state") ? leadState :
                                                        //                 (viewType === "Lead" && item.field === "city") ? leadCity :
                                                        //                     (viewType === "Contact" && item.field === "state") ? contactState :
                                                        //                         (viewType === "Contact" && item.field === "city") ? contactCity :
                                                        //                             (viewType === "Account" && item.field === "state") ? accountState :
                                                        //                                 (viewType === "Account" && item.field === "city") ? accountCity :
                                                        //                                     (viewType === "User" && item.field === "state") ? userState :
                                                        //                                         (viewType === "User" && item.field === "city") ? userCity :
                                                        //                                             // (viewType === "Case" && item.field === "case_creater") ? creatorList :
                                                        //                                             (viewType === "Case" && item.field === "account_name") ? caseAccounts :
                                                        //                                                 ""}
                                                        //         onSelect={(value) => {
                                                        //             updateCondition(groupData?.id, item.id, 'value', value, item.Key, item.Currency)
                                                        //             if (pageFrom === "ApprovalDefineQuery"||pageFrom === "AssignmentDefineQuery"||pageFrom === "AutomationDefineQuery") {
                                                        //                 updateFrondendCondition(groupData?.id, item.id, 'value', value, item.Key, item.Currency);
                                                        //             }
                                                        //         }}
                                                        //         onChange={(value) => {
                                                        //             updateCondition(groupData?.id, item.id, 'value', value, item.Key, item.Currency)
                                                        //             if (pageFrom === "ApprovalDefineQuery"||pageFrom === "AssignmentDefineQuery"||pageFrom === "AutomationDefineQuery") {
                                                        //                 updateFrondendCondition(groupData?.id, item.id, 'value', value, item.Key, item.Currency);
                                                        //             }
                                                        //         }}
                                                        //         style={{ width: '100%' }}
                                                        //         placeholder="Type or select an option"
                                                        //         filterOption={(inputValue, option) =>
                                                        //             option.value.toLowerCase().includes(inputValue.toLowerCase())
                                                        //         }
                                                        //     >
                                                        //         <Input />
                                                        //     </AutoComplete>
                                                        //     :
                                                        ready ? (<Select placeholder="Select Value"
                                                            {...((
                                                                (isOwnerField || (viewType === "User" && item.field === "email")) &&
                                                                !(item.field === "account_name" && (viewType === "Lead" || viewType === "Case"))
                                                            ) ? { optionLabelProp: "label" } : {})}
                                                            mode={isMultiple && 'multiple'}
                                                            showSearch
                                                            disabled={!isEditable}
                                                            style={{ width: "100%" }}
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                (
                                                                    (isOwnerField || (viewType === "User" && item.field === "email")) &&
                                                                    !(item.field === "account_name" && (viewType === "Lead" || viewType === "Case"))
                                                                )
                                                                    ? (() => {
                                                                        const usernameElement = option.children.props.children[1].props.children[0];
                                                                        if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                            const username = String(usernameElement.props.children);
                                                                            return username.toLowerCase().includes(input.toLowerCase());
                                                                        }
                                                                        return false;
                                                                    })()
                                                                    : option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            name="value"
                                                            value={item.value}
                                                            onChange={(value, option) => {
                                                                updateCondition(groupData?.id, item.id, 'value', value, item.Key, item.Currency)
                                                                if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
                                                                    if (isMultiple) {
                                                                        const names = Array.isArray(option) ? option?.map(opt => opt?.data) : [];
                                                                        updateFrondendCondition(groupData?.id, item.id, 'value', names, item.Key, item.Currency);
                                                                    } else {
                                                                        updateFrondendCondition(groupData?.id, item.id, 'value', option?.data, item.Key, item.Currency);
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {(viewType === "Lead" && item.field === "account_name") && <> {account2} </>}
                                                            {(viewType === "Lead" && item.field === "state") && <>  {leadState} </>}
                                                            {(viewType === "Lead" && item.field === "city") && <>  {leadCity} </>}
                                                            {(viewType === "Lead" && item.field === "country") && <>  {leadCountry} </>}
                                                            {(viewType === "Contact" && item.field === "country") && <>  {contactCountry} </>}
                                                            {(viewType === "Contact" && item.field === "state") && <>  {contactState} </>}
                                                            {(viewType === "Contact" && item.field === "city") && <>  {contactCity} </>}
                                                            {(viewType === "Account" && item.field === "state") && <>  {accountState} </>}
                                                            {(viewType === "Account" && item.field === "city") && <>  {accountCity} </>}
                                                            {(viewType === "Account" && item.field === "country") && <>  {accountCountry} </>}
                                                            {(viewType === "User" && item.field === "state") && <>  {userState} </>}
                                                            {(viewType === "User" && item.field === "city") && <>  {userCity} </>}
                                                            {(viewType === "User" && item.field === "country") && <>  {userCountry} </>}
                                                            {(viewType === "Case" && item.field === "account_name") && <>  {caseAccounts}</>}
                                                            {((viewType !== "User" && viewType !== "Account" && viewType !== "Contact" && viewType !== "Lead") && item.field === "country") &&
                                                                allCountry?.map((option, i) => (
                                                                    <Option key={i} value={option.country} data={option.country}>
                                                                        {option.country}
                                                                    </Option>
                                                                ))}
                                                            {(item.field === "case_owner") &&
                                                                users.filter(item => item.department === "Sales" || item.department === "Customer Care")?.map((option, i) => (
                                                                    <Option value={option.userId} data={`${option.firstName} ${option.lastName}`}
                                                                        label={(
                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                <div className='Div_flex2'>
                                                                                    <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                        {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                            < img src={option.profilePic} alt="profile" />
                                                                                            :
                                                                                            <span className="image_icon UserIcon">
                                                                                                {option.firstName.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        }
                                                                                        <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        key={i}>
                                                                        <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                            <div>
                                                                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                    < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.firstName.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                <p style={{ margin: 0 }}>{option.username}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {(item.field === "parent_case") &&
                                                                allCaseList?.map((option, i) => (
                                                                    <Option value={option.caseId} key={i} data={option.caseSubject} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.caseSubject} (${option.caseNumber})`} style={{ cursor: "default" }}>
                                                                                    <span className="image_icon">
                                                                                        {option.caseSubject.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                    <span className='div-ellipsis'>{option.caseSubject}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>)}>
                                                                        <div className='UserList-dropdown' title={`${option.caseSubject} (${option.caseNumber})`}>
                                                                            <div>
                                                                                <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                    {option.caseSubject.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.caseSubject}</p>
                                                                                <p style={{ margin: 0 }}>{option.caseNumber}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {(item.field === "child_case") &&
                                                                allCaseList?.map((option, i) => (
                                                                    <Option value={option.caseId} key={i} data={option.caseSubject} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.caseSubject} (${option.caseNumber})`}>
                                                                            <span className='details_span_Tag' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                {option.caseSubject.slice(0, 1).toUpperCase()}
                                                                            </span>

                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.caseSubject}</p>
                                                                        </div>)}>
                                                                        <div className='UserList-dropdown' title={`${option.caseSubject} (${option.caseNumber})`}>
                                                                            <div>
                                                                                <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                    {option.caseSubject.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.caseSubject}</p>
                                                                                <p style={{ margin: 0 }}>{option.caseNumber}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {(item.field === "followers") &&
                                                                users?.map((option, i) => (
                                                                    <Option value={option.userId} key={i} data={`${option.firstName} ${option.lastName}`} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.firstName} ${option.lastName} (${option.caseNumber})`}>
                                                                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                < img src={option.profilePic} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                                                                :
                                                                                <span className='details_span_Tag UserIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                    {option.firstName.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                            }
                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                        </div>
                                                                    )}>
                                                                        <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.caseNumber})`}>
                                                                            <div>
                                                                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                    < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.firstName.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                <p style={{ margin: 0 }}>{option.username}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {item.field === "service_line_owner" &&
                                                                users.filter(item => item.department === "Service Line")?.map((option, i) => (
                                                                    <Option value={option.userId} data={`${option.firstName} ${option.lastName}`}
                                                                        label={(
                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                <div className='Div_flex2'>
                                                                                    <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                        {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                            < img src={option.profilePic} alt="profile" />
                                                                                            :
                                                                                            <span className="image_icon UserIcon">
                                                                                                {option.firstName.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        }
                                                                                        <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        key={i}>
                                                                        <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                            <div>
                                                                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                    < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.firstName.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                <p style={{ margin: 0 }}>{option.username}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {(item.field === 'task_owner' || item.field === 'email' || item.field === 'reporting_manager_id' || item.field === "assign_to") &&
                                                                users?.map((option) => (
                                                                    <Option value={item.field === 'email' ? option.username : option.userId} key={option.id} data={item.field === 'email' ? option.username : `${option.firstName} ${option.lastName}`} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                        < img src={option.profilePic} alt="profile" />
                                                                                        :
                                                                                        <span className="image_icon UserIcon">
                                                                                            {option.firstName.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }
                                                                                    {item.field === 'email' ?
                                                                                        <span className='div-ellipsis'>{option.username}</span> :
                                                                                        <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}>
                                                                        <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                            <div>
                                                                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                    < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.firstName.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                <p style={{ margin: 0 }}>{option.username}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {item.field === "parent_service_line" && <>
                                                                {serviceData?.map((option, i) => (
                                                                    <Option value={option.service_line_name} key={i} data={option.service_line_name} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={option.service_line_name} style={{ cursor: "default" }}>
                                                                                    <span className="image_icon">
                                                                                        {option.service_line_name.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                    <span className='div-ellipsis'>{option.service_line_name}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>)}>
                                                                        <div className='UserList-dropdown' title={option.service_line_name}>
                                                                            <div>
                                                                                <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                    {option.service_line_name.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.service_line_name}</p>
                                                                                <p style={{ margin: 0, display: "none" }}>0</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))} </>}
                                                            {item.field === "manufacturer_name" && <>
                                                                {accountbyType.filter(item => item.account_type_name === "Vendor" || item.account_type_name === "Reseller")?.map((option) => (
                                                                    <Option value={option.account_name} data={option.account_name} key={option.id} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                                                                    {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                        < img src={option.account_profile} alt="profile" />
                                                                                        :
                                                                                        <span className="image_icon AccountIcon">
                                                                                            {option.account_name.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }
                                                                                    <span className='div-ellipsis'>{option.account_name}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>)}>
                                                                        <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                                                            <div>
                                                                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                    < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.account_name.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                <p style={{ margin: 0 }}>{option.account_number}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}</>}
                                                            {(item.field === "lead_owner" || item.field === 'account_owner' || item.field === 'deal_owner') &&
                                                                users.filter(item => item.department === "Sales")?.map((option, i) => (
                                                                    <Option value={option.userId} key={i} data={`${option.firstName} ${option.lastName}`} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                        < img src={option.profilePic} alt="profile" />
                                                                                        :
                                                                                        <span className="image_icon UserIcon">
                                                                                            {option.firstName.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }
                                                                                    <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}>
                                                                        <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`} >
                                                                            <div>
                                                                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                    < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.firstName.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                <p style={{ margin: 0 }}>{option.username}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {item.field === "date_format" && <>
                                                                {dateFormateList}</>}
                                                            {item.field === "Time_format" && <>
                                                                {timeFormateList}</>}
                                                            {item.field === "company_role_id" &&
                                                                allCompanyRole?.map((option, i) => (
                                                                    <Option value={option.companyRoleId} key={i} data={option.companyRole}>
                                                                        {option.companyRole}
                                                                    </Option>))}
                                                            {item.field === "time_zone" &&
                                                                allTimeZone?.map((option, i) => (
                                                                    <Option key={i} value={option.timeZone} data={option.timeZone}>
                                                                        {option.timeZone}
                                                                    </Option>
                                                                ))}
                                                            {/* {item.field === "language" &&
                                                                allLanguage?.map((option, i) => (
                                                                    <Option key={i} value={option.language} data={option.language}>
                                                                        {option.language}
                                                                    </Option>
                                                                ))} */}
                                                            {item.field === "language" && <Option data="English" value="English">English</Option>}
                                                            {item.field === "role_id" &&
                                                                allRole?.map((option, i) => (
                                                                    <Option value={option.id} key={i} data={option.roleName}>
                                                                        {option.roleName}
                                                                    </Option>))}
                                                            {item.field === "department" &&
                                                                <>{department}</>}
                                                            {item.field === "seniority_level_id" && <>
                                                                {seniority}</>}
                                                            {item.field === "organization_level" && <>
                                                                {seniority1}</>}
                                                            {item.field === "user_group_ids" &&
                                                                allusergroupList?.map((option, i) => (
                                                                    <Option key={i} value={option.userGroupId} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.userGroupName} (${option.groupUserCount} Users)`} style={{ cursor: "default" }}>
                                                                                    <span className="image_icon GroupIcon">
                                                                                        {option.userGroupName.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                    <span className='div-ellipsis'>{option.userGroupName}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>)}>
                                                                        <div className='UserList-dropdown' title={`${option.userGroupName} (${option.groupUserCount} Users)`}>
                                                                            <div>
                                                                                <span className='details_span_Tag GroupIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                    {option.userGroupName.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.userGroupName}</p>
                                                                                <p style={{ margin: 0 }}>{option.groupUserCount} (Users)</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {((viewType !== "Lead" && viewType !== "Case") && (item.field === "account_id" || item.field === "account_name")) &&
                                                                account.filter((item) => item.account_type_name === "Customer")?.map((option) => (
                                                                    <Option value={option.account_id} key={option.id} data={option.account_name} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                                                                    {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                        < img src={option.account_profile} alt="profile" />
                                                                                        :
                                                                                        <span className="image_icon AccountIcon">
                                                                                            {option.account_name.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }
                                                                                    <span className='div-ellipsis'>{option.account_name}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>)}>
                                                                        <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                                                            <div>
                                                                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                    < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.account_name.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                <p style={{ margin: 0 }}>{option.account_number}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {item.field === "contact_person" &&
                                                                contact?.map((option, i) => (
                                                                    <Option value={option.contacts_id} key={i} data={`${option.first_name} ${option.last_name}`}
                                                                        label={(
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.first_name} ${option.last_name} (${option?.email})`}>
                                                                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                    < img src={option.contact_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag ContactIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.first_name?.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                                                            </div>)} >
                                                                        <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option?.email})`}>
                                                                            <div>
                                                                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                    < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.first_name?.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                                                                <p style={{ margin: 0 }}>{option?.email}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {item.field === "parent_organization" &&
                                                                account.filter((item) => item.account_type_name === "Customer")?.map((option) => (
                                                                    <Option value={option.account_id} key={option.id} data={option.account_name} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.account_name} (${option?.account_number})`} style={{ cursor: "default" }}>
                                                                                    {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                        < img src={option.account_profile} alt="profile" />
                                                                                        :
                                                                                        <span className="image_icon AccountIcon">
                                                                                            {option.account_name.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }
                                                                                    <span className='div-ellipsis'>{option.account_name}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>)}>
                                                                        <div className='UserList-dropdown' title={`${option.account_name} (${option?.account_number})`}>
                                                                            <div>
                                                                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                    < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.account_name.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                <p style={{ margin: 0 }}>{option.account_number}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {item.field === "task_type_id" &&
                                                                taskType?.map((option) => (
                                                                    <Option value={option.taskTypeId} key={option.id} data={option.taskTypeName}>
                                                                        {option.taskTypeName}
                                                                    </Option>))}
                                                            {(item.field === "lead_source_id" || item.field === "contact_source_id") &&
                                                                leadsource?.map((option) => (
                                                                    <Option value={option.leadSourceId} key={option.id} data={option.leadSourceName}>
                                                                        {option.leadSourceName}
                                                                    </Option>))}
                                                            {item.field === "lead_status_id" &&
                                                                leadStatus?.map((option) => (
                                                                    <Option value={option.leadStatusId} key={option.id} data={option.leadStatusName}>
                                                                        {option.leadStatusName}
                                                                    </Option>))}
                                                            {item.field === "task_status_id" &&
                                                                taskStatus?.map((option) => (
                                                                    <Option value={option.taskStatusId} key={option.id} data={option.taskStatusName}>
                                                                        {option.taskStatusName}
                                                                    </Option>))}
                                                            {item.field === "reporting_to" &&
                                                                contact?.map((option, i) => (
                                                                    <Option value={option.contacts_id} key={i} data={`${option.first_name} ${option.last_name}`} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                    {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                        < img src={option.contact_profile} alt="profile" />
                                                                                        :
                                                                                        <span className="image_icon ContactIcon">
                                                                                            {option.first_name.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }
                                                                                    <span className='div-ellipsis'>{`${option.first_name} ${option.last_name}`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>)} >
                                                                        <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                            <div>
                                                                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                    < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.first_name.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                                                                <p style={{ margin: 0 }}>{option.email}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {item.field === "competition" &&
                                                                accountbyType.filter((item) => item.account_type_name === "Competitor")?.map((option) => (
                                                                    <Option value={option.account_id} key={option.id} data={option.account_name} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.account_name} (${option?.account_number})`} >
                                                                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                < img src={option.account_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                                                                :
                                                                                <span className='details_span_Tag AccountIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                    {option.account_name?.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                            }
                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                        </div>)}>
                                                                        <div className='UserList-dropdown' title={`${option.account_name} (${option?.account_number})`} >
                                                                            <div>
                                                                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                    < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.account_name?.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                <p style={{ margin: 0 }}>{option?.account_number}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {item.field === "parent_deal_id" &&
                                                                dealListData?.map((option, i) => (
                                                                    <Option value={option.deals_id} key={i} data={option.deal_name} label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.deal_name} (${option?.pipelineStage})`} style={{ cursor: "default" }}>
                                                                                    {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                                                                        < img src={option.deal_profile} alt="profile" />
                                                                                        :
                                                                                        <span className="image_icon DealIcon">
                                                                                            {option.deal_name.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }
                                                                                    <span className='div-ellipsis'>{option.deal_name}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>)}>
                                                                        <div className='UserList-dropdown' title={`${option.deal_name} (${option?.pipelineStage})`} >
                                                                            <div>
                                                                                {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                                                                    < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                    :
                                                                                    <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                        {option.deal_name.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }</div>
                                                                            <div>
                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                                                                                <p style={{ margin: 0 }}>{option.pipelineStage}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Option>))}
                                                            {item.field === "account_type" &&
                                                                typeData?.map((option, i) => (
                                                                    <Option value={option.accountTypeId} key={i} data={option.accountTypeName}>
                                                                        {option.accountTypeName}
                                                                    </Option>))}
                                                            {item.field === "industry" &&
                                                                industryData?.map((option, i) => (
                                                                    <Option value={option.industryId} key={i} data={option.industryName}>
                                                                        {option.industryName}
                                                                    </Option>))}
                                                            {item.field === "ownership" &&
                                                                ownerShipData?.map((option, i) => (
                                                                    <Option value={option.ownershipId} key={i} data={option.ownershipName}>
                                                                        {option.ownershipName}
                                                                    </Option>))}
                                                            {item.field === "deal_type" &&
                                                                <>{dealType?.map((option, i) => (
                                                                    <Option value={option.dealTypeId} key={i} data={option.dealTypeName}>
                                                                        {option.dealTypeName}
                                                                    </Option>))}</>}
                                                            {item.field === "pipeline_stage" &&
                                                                <>{pipeLineStage?.map((option, i) => (
                                                                    <Option value={option.pipelineStageId} key={i} data={option.pipelineStageName}>
                                                                        {option.pipelineStageName}
                                                                    </Option>))} </>}
                                                            {(viewType === "Deal" && item.field === "priority") &&
                                                                <> {dealPriority?.map((option, i) => (
                                                                    <Option value={option.priorityId} key={i} data={option.priorityName}>
                                                                        {option.priorityName}
                                                                    </Option>))}</>}
                                                            {(viewType === "Task" && item.field === "priority") &&
                                                                <> {dealPriority?.map((option, i) => (
                                                                    <Option value={option.priorityName} key={i} data={option.priorityName}>
                                                                        {option.priorityName}
                                                                    </Option>))}</>}
                                                            {item.field === "annual_revenue" &&
                                                                <>{revenue}</>}
                                                            {item.field === "nom_of_employees" &&
                                                                <>{noofemployee} </>}
                                                            {item.field === "customer_status" &&
                                                                <>{customerStatus}</>}
                                                            {item.field === "product_category" && <>
                                                                {productCat}</>}
                                                            {item.field === "rating" &&
                                                                <>{rating}</>}
                                                            {item.field === "title" &&
                                                                <>{titles}</>}
                                                            {item.field === "deal_hold_reason" &&
                                                                dealOnHold?.map((option, i) => (
                                                                    <Option value={option.dealHoldReasonId} key={i} data={option.dealOnHoldReasonName}>
                                                                        {option.dealOnHoldReasonName}
                                                                    </Option>))}
                                                            {item.field === "deal_lost_reason" &&
                                                                dealLost?.map((option, i) => (
                                                                    <Option value={option.dealLostReasonId} key={i} data={option.dealLostReasonName}>
                                                                        {option.dealLostReasonName}
                                                                    </Option>))}
                                                            {item.field === "deal_won_reason" &&
                                                                dealWon?.map((option, i) => (
                                                                    <Option value={option.dealWonReasonId} key={i} data={option.dealWonReasonName}>
                                                                        {option.dealWonReasonName}
                                                                    </Option>))}
                                                            {item.field === "resell" && <>
                                                                <Option data="true" value>Yes</Option>
                                                                <Option data="false" value={false}>No</Option></>}
                                                            {(item.field === 'case_type') && <>
                                                                <Option value="Service Request" data="Service Request">Service Request</Option>
                                                                <Option value="Problem" data="Problem">Problem</Option>
                                                                <Option value="Question" data="Question">Question</Option> </>}
                                                            {(item.field === 'case_status') && <>
                                                                <Option value="New" data="New">New</Option>
                                                                <Option value="Closed" data="Closed">Closed</Option>
                                                                <Option value="On Hold" data="On Hold">On Hold</Option>
                                                                <Option value="Escalated" data="Escalated">Escalated</Option></>}
                                                            {(item.field === 'case_origin') && <>
                                                                <Option value="Email" data="Email">Email</Option>
                                                                <Option value="Phone" data="Phone">Phone</Option>
                                                                <Option value="Web" data="Web">Web</Option></>}
                                                            {(item.field === 'case_priority') && <>
                                                                <Option value="Low" data="Low">Low</Option>
                                                                <Option value="Medium" data="Medium">Medium</Option>
                                                                <Option value="High" data="High">High</Option> </>}
                                                            {item.field === "subtype" &&
                                                                <><Option value="Request for Proposal" data="Request for Proposal">Request for Proposal</Option>
                                                                    <Option value="Staff Augmentation" data="Staff Augmentation">Staff Augmentation</Option>
                                                                    <Option value="Product and Services" data="Product and Services">Product and Services</Option>
                                                                    <Option value="Others" data="Others">Others</Option></>}
                                                            {item.field === "commit_status" &&
                                                                <> <Option value="Hard Commit" data="Hard Commit">Hard Commit</Option>
                                                                    <Option value="Soft Commit" data="Soft Commit">Soft Commit</Option></>}
                                                            {item.field === "qualified" &&
                                                                <><Option value="Qualified" data="Qualified">Qualified</Option>
                                                                    <Option value="Not-Qualified" data="Not-Qualified">Not-Qualified</Option></>}
                                                            {item.field === "margin_calculation_method" && <>
                                                                <Option value="Fixed" data="Fixed">Fixed</Option>
                                                                <Option value="Percentage %" data="Percentage %">Percentage %</Option>
                                                                <Option value="Price Up" data="Price Up">Price Up</Option></>}
                                                            {item.field === "product_active" && <>
                                                                <Option value='Yes' data='Yes'>Active</Option>
                                                                <Option value='No' data='No'>Inactive</Option> </>}
                                                            {(item.field === "email_opt_out" || item.field === "email_otp_out" || item.field === "is_converted") && <>
                                                                <Option data="Yes" value>Yes</Option>
                                                                <Option data="No" value={false}>No</Option>
                                                            </>}
                                                        </Select>
                                                        ) : (
                                                            <div>
                                                                <Skeleton.Input style={{ width: "100%" }} active />
                                                            </div>
                                                        )
                                                    }
                                                </>) :
                                                    (item.Key === 'Boolean') ? (
                                                        <Select placeholder="Select Value"
                                                            showSearch
                                                            style={{ width: "100%" }}
                                                            optionFilterProp="children"
                                                            name="value"
                                                            disabled={!isEditable}
                                                            value={item.value}
                                                            onChange={(value, option) => {
                                                                updateCondition(groupData?.id, item.id, 'value', value, item.Key, item.Currency)
                                                                if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
                                                                    updateFrondendCondition(groupData?.id, item.id, 'value', option.data, item.Key, item.Currency)
                                                                }
                                                            }}
                                                        >
                                                            {(item.field === "email_opt_out" || item.field === "email_otp_out" || item.field === "is_converted") && <>
                                                                <Option data="Yes" value>Yes</Option>
                                                                <Option data="No" value={false}>No</Option>
                                                            </>}
                                                            {item.field === "resell" && <>
                                                                <Option data="true" value>Yes</Option>
                                                                <Option data="false" value={false}>No</Option></>}
                                                        </Select>
                                                    ) :
                                                        (item.Key === 'Free Text' || item.Key === 'Numbers') ? (
                                                            (item.Currency === 'YES') ? <>
                                                                <Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                    prefix={currencySettings?.symbol}
                                                                    name="value"
                                                                    disabled={!isEditable}
                                                                    value={item.value}
                                                                    onChange={(e) => {
                                                                        const inputValue = e.target.value;
                                                                        const decimalLimit = CurencyDecimalPlace || 2;
                                                                        const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                        if (!basicNumberCheck) {
                                                                            message.error('Please enter a valid number');
                                                                            return;
                                                                        }
                                                                        if (inputValue === ".") {
                                                                            message.error('Please enter a valid number');
                                                                            return;
                                                                        }
                                                                        const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalLimit}})?$`);
                                                                        if (inputValue && !decimalRegex.test(inputValue)) {
                                                                            message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                            return;
                                                                        }
                                                                        updateCondition(groupData?.id, item.id, 'value', inputValue, item.Key, item.Currency)
                                                                        if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
                                                                            updateFrondendCondition(groupData?.id, item.id, 'value', inputValue, item.Key, item.Currency)
                                                                        }
                                                                    }} />
                                                            </> : <Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                prefix={shouldValidate && "%"}
                                                                name="value"
                                                                disabled={!isEditable}
                                                                value={item.value}
                                                                onChange={(e) => {
                                                                    const inputValue = e.target.value;
                                                                    const decimalLimit = CurencyDecimalPlace || 2;
                                                                    if (item.Key === 'Numbers') {
                                                                        const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                        if (!basicNumberCheck) {
                                                                            message.error('Please enter a valid number');
                                                                            return;
                                                                        }
                                                                        if (inputValue === ".") {
                                                                            message.error('Please enter a valid number');
                                                                            return;
                                                                        }
                                                                        const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalLimit}})?$`);
                                                                        if (inputValue && !decimalRegex.test(inputValue)) {
                                                                            message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                            return;
                                                                        }
                                                                        if (shouldValidate) {
                                                                            const num = Number(inputValue);
                                                                            if (inputValue && (num < 0 || num > 100)) {
                                                                                message.error('Percentage must be between 0 and 100');
                                                                                return;
                                                                            }
                                                                        }
                                                                    }
                                                                    updateCondition(groupData?.id, item.id, 'value', inputValue, item.Key, item.Currency)
                                                                    if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
                                                                        updateFrondendCondition(groupData?.id, item.id, 'value', inputValue, item.Key, item.Currency)
                                                                    }
                                                                }} />
                                                        ) :
                                                            (item.Key === 'Date') ?
                                                                ((item.operator === "=" || item.operator === "!=" || item.operator === "<" || item.operator === ">") ?
                                                                    <DatePicker
                                                                        name="value"
                                                                        disabled={!isEditable}
                                                                        onChange={(date) => {
                                                                            updateCondition(groupData?.id, item.id, 'value', date ? date.format("YYYY-MM-DD") : null, item.Key, item.Currency)
                                                                            if (pageFrom === "ApprovalDefineQuery" || pageFrom === "AssignmentDefineQuery" || pageFrom === "AutomationDefineQuery") {
                                                                                updateFrondendCondition(groupData?.id, item.id, 'value', date ? date.format("YYYY-MM-DD") : null, item.Key, item.Currency)
                                                                            }
                                                                        }}
                                                                        value={item.value ? moment(item.value, "YYYY-MM-DD") : null}
                                                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                    /> : <></>)
                                                                : <></>)}
                                        </Form.Item>
                                    </Col>
                                    {
                                        isEditable &&
                                        groupData?.items?.filter(i => i.type === 'condition').length > 1 && (
                                            <Col span={2}>
                                                <Form.Item>
                                                    <div style={{
                                                        textAlign: "end",
                                                        marginRight: 20
                                                    }} title='Delete Condition'>
                                                        <FeatherIcon icon="trash-2" size={20} className="fetcherDelete-Icon" style={{ marginTop: 13 }} onClick={() => deleteCondition(groupData?.id, item.id)}
                                                        // onMouseEnter={() => {
                                                        //     const idx = groupData.items.findIndex(
                                                        //         (i) => i.type === 'condition' && i.id === item.id
                                                        //     );
                                                        //     const hasPreviousCondition = groupData.items
                                                        //         .slice(0, idx)
                                                        //         .some((i) => i.type === 'condition');
                                                        //     const ids = [item.id];
                                                        //     if (!hasPreviousCondition) {
                                                        //         ids.push(...collectContiguousGroupsAfter(groupData.items, idx));
                                                        //     }

                                                        //     setHighlightIds(ids);
                                                        // }}
                                                        // onMouseLeave={() => setHighlightIds([])}
                                                        />
                                                    </div>
                                                </Form.Item>
                                            </Col>)
                                    }
                                </Row>
                            </div>
                        );
                    }
                    return renderGroup(item, indent + 20, depth + 1);
                })}
                {isEditable ?
                    <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                        <Button
                            size="small"
                            type="dashed"
                            style={{ display: "flex", alignItems: "center", gap: 5 }}
                            onClick={() => addConditionToGroup(groupData?.id)}
                        >
                            <FeatherIcon icon="plus" size={14} /> Add Condition
                        </Button>
                        {canAddSubGroup && (<Button
                            size="small"
                            type="dashed"
                            style={{ display: "flex", alignItems: "center", gap: 5 }}
                            onClick={() => addSubGroup(groupData?.id)}
                        >
                            <FeatherIcon icon="layers" size={14} /> Add Group
                        </Button>)}
                        {isEditable && depth > 0 && (
                            <Button
                                size="small"
                                danger
                                style={{ display: "flex", alignItems: "center", gap: 5 }}
                                onClick={() => deleteGroup(groupData?.id)}
                            >
                                <FeatherIcon icon="trash-2" size={14} /> Delete Group
                            </Button>
                        )}
                    </div> : <></>}
            </div >
        );
    };
    return (
        <>
            {(uiLoad && group) ? <div style={{
                // padding: "10px 30px 15px",
                // borderRadius: 10,
                // border: "0.1px solid #cdcdcd",
                // boxShadow: "0 1px 10px #00000026",
                // background: "#f8f9fa",
            }} className='view-builder-cardByJ'>
                <div className='view-builder-headerByJ'><div><h4>Filter Conditions</h4>
                    {(pageFrom !== "ViewQuery" && pageFrom !== "BulkQuery") ? <p>Combine multiple conditions using AND/OR to refine results, then run the query to view matching records</p> : <></>}</div></div>
                <div style={{ padding: '0px 0px 16px' }}>{renderGroup(group)}</div>
            </div>
                :
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "120px" }}>
                    <Spin />
                </div>
            }
        </>
    );
};
QueryBuilderFunction.propTypes = {
    currencySettings: PropTypes.object,
    queryField: PropTypes.array.isRequired,
    viewType: PropTypes.string.isRequired,
    group: PropTypes.object.isRequired,
    setGroup: PropTypes.func.isRequired,
    pageFor: PropTypes.string.isRequired,
    setUiLoad: PropTypes.func.isRequired,
    uiLoad: PropTypes.bool.isRequired,
    frontendGroup: PropTypes.object.isRequired,
    setFrontendGroup: PropTypes.func.isRequired,
    pageFrom: PropTypes.string.isRequired,
    isEditable: PropTypes.bool.isRequired,
};
export default QueryBuilderFunction;